module.exports = __webpack_public_path__ + "img/full-slide-5.4f711fd7.jpg";